import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../../api';
import { useCart } from '../../context/CartContext';

const standImages = {
  'Les Canons de la Daronne': 'https://halles-cartoucherie.fr/wp-content/uploads/2023/08/canon_site_header_1.jpg',
  'Bao House': 'https://halles-cartoucherie.fr/wp-content/uploads/2023/08/bao_site_header_2.jpg',
  'Washoku': 'https://halles-cartoucherie.fr/wp-content/uploads/2026/02/header-washoku.webp',
  'Maître Ramen': 'https://halles-cartoucherie.fr/wp-content/uploads/2025/09/maitre-ramen.jpg',
  'Carne': 'https://halles-cartoucherie.fr/wp-content/uploads/2025/09/carne.jpg',
  'Coolquillettes': 'https://halles-cartoucherie.fr/wp-content/uploads/2025/09/header-coolquillettes.jpg',
  'Mexcal': 'https://halles-cartoucherie.fr/wp-content/uploads/2025/09/mexcal.jpg',
  "La Truffe et l'Andouille": 'https://halles-cartoucherie.fr/wp-content/uploads/2023/08/andouille_site_header_1.jpg',
  'Boni and Fries': 'https://halles-cartoucherie.fr/wp-content/uploads/2023/08/boniface_site_header_1.jpg',
  'Tata La Cucina': 'https://halles-cartoucherie.fr/wp-content/uploads/2023/08/tata_site_header_2.jpg',
  'Rotisserie Rio': 'https://halles-cartoucherie.fr/wp-content/uploads/2023/08/rio_site_header_1.jpg',
  'Maison du Curry': 'https://halles-cartoucherie.fr/wp-content/uploads/2023/08/curry_site_header_1.jpg',
  'La Cidrerie Basque': 'https://halles-cartoucherie.fr/wp-content/uploads/2023/08/Pintxos_site_header_1.jpg',
  'Shali': 'https://halles-cartoucherie.fr/wp-content/uploads/2025/09/shali.jpg',
  'I Scream': 'https://halles-cartoucherie.fr/wp-content/uploads/2024/01/chapiteau.webp',
  'Ekylibre': 'https://halles-cartoucherie.fr/wp-content/uploads/2025/09/ekylibre.jpg',
  'Les Casiers Fermiers': 'https://halles-cartoucherie.fr/wp-content/uploads/2023/08/casier_site_header_2.jpg',
  'Les Bars': 'https://halles-cartoucherie.fr/wp-content/uploads/2023/08/bar_site_header_1.jpg',
  'Diabateba': 'https://halles-cartoucherie.fr/wp-content/uploads/2023/08/Diabate_site_header_1.jpg',
  'Bobine': 'https://halles-cartoucherie.fr/wp-content/uploads/2025/09/header-bobine.jpg',
  'Les Jambon Beurre': 'https://halles-cartoucherie.fr/wp-content/uploads/2025/09/jambon-beurre.jpg',
  'Chez Yfic': 'https://halles-cartoucherie.fr/wp-content/uploads/2023/08/yfigg_site_header_2.jpg',
  'Acapella': 'https://halles-cartoucherie.fr/wp-content/uploads/2023/08/acapella_site_header_1.jpg',
  'Boniface': 'https://halles-cartoucherie.fr/wp-content/uploads/2023/08/boniface_site_header_1.jpg',
  'Le Tout Rouge': 'https://halles-cartoucherie.fr/wp-content/uploads/2023/08/toutrouge_site_header_1.jpg',
};

const categories = [
  { key: 'all', label: 'Tous' },
  { key: 'grillade', label: 'Grillades' },
  { key: 'asiatique', label: 'Asiatique' },
  { key: 'italien', label: 'Italien' },
  { key: 'mexicain', label: 'Mexicain' },
  { key: 'healthy', label: 'Healthy' },
  { key: 'bar_vin', label: 'Bar a Vin' },
  { key: 'patisserie', label: 'Patisserie' },
  { key: 'glacier', label: 'Glacier' },
];

export default function StandList() {
  const [stands, setStands] = useState([]);
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const { tableId } = useParams();
  const { count, total } = useCart();

  useEffect(() => {
    api.getStands().then(setStands);
  }, []);

  const filteredStands = stands.filter(stand => {
    if (activeCategory !== 'all' && stand.type !== activeCategory) return false;
    if (searchQuery && !stand.nom.toLowerCase().includes(searchQuery.toLowerCase())) return false;
    return true;
  });

  return (
    <div className="min-h-screen bg-[#FEFCF8]">
      {/* Sticky header */}
      <header className="sticky top-0 z-50 bg-[#FEFCF8]/95 backdrop-blur-sm border-b border-[#F3DFC0]">
        <div className="max-w-lg mx-auto px-4 py-3 flex items-center justify-between">
          <div>
            <h1 className="font-serif font-bold text-xl text-[#332A1C]">
              Les Halles
            </h1>
            {tableId && (
              <span className="text-xs text-[#8B7355]">
                Table {tableId}
              </span>
            )}
          </div>
          <Link
            to="/cart"
            className="relative p-2.5"
            aria-label="Panier"
          >
            <svg className="w-6 h-6 text-[#332A1C]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
            </svg>
            {count > 0 && (
              <span className="absolute -top-1 -right-1 bg-[#C4673D] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">
                {count}
              </span>
            )}
          </Link>
        </div>
      </header>

      <div className="max-w-lg mx-auto px-4 pt-5 pb-32">
        {/* Page title */}
        <div className="mb-5">
          <h2 className="font-serif text-[#332A1C] text-2xl font-bold">
            Nos Stands
          </h2>
          <p className="text-[#8B7355] text-sm mt-1">
            Choisissez un stand pour d&eacute;couvrir sa carte
          </p>
        </div>

        {/* Search bar */}
        <div className="relative mb-4">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
            <svg className="w-4 h-4 text-[#8B7355]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
            </svg>
          </div>
          <input
            type="text"
            placeholder="Rechercher un stand..."
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            className="w-full bg-[#FEFCF8] border border-[#E2D1B8] rounded-xl pl-11 pr-4 py-3 text-sm text-[#332A1C] placeholder-[#8B7355]/60 focus:outline-none focus:border-[#C4673D] focus:ring-1 focus:ring-[#C4673D]/30 transition-colors"
          />
        </div>

        {/* Category filter pills */}
        <div className="flex gap-2 overflow-x-auto pb-4 mb-4 scrollbar-hide" style={{ WebkitOverflowScrolling: 'touch' }}>
          {categories.map(cat => (
            <button
              key={cat.key}
              onClick={() => setActiveCategory(cat.key)}
              className={`flex-shrink-0 px-4 py-2 rounded-xl text-sm font-sans transition-all duration-200 ${
                activeCategory === cat.key
                  ? 'bg-[#C4673D] text-white font-semibold'
                  : 'bg-white border border-[#E2D1B8] text-[#8B7355] hover:border-[#C4673D]/40 hover:text-[#C4673D]'
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {/* Stand grid */}
        <div className="grid grid-cols-2 gap-3">
          {filteredStands.map(stand => {
            const imageUrl = standImages[stand.nom];

            return (
              <Link
                key={stand.id}
                to={`/stand/${stand.id}`}
                className="bg-white rounded-2xl overflow-hidden group transition-all duration-300 hover:shadow-[0_4px_20px_rgba(139,66,37,0.14)]"
                style={{ boxShadow: '0 2px 15px rgba(139,66,37,0.08)' }}
              >
                {/* Photo area */}
                <div className="aspect-[4/3] relative overflow-hidden bg-[#F3DFC0]">
                  {imageUrl ? (
                    <img
                      src={imageUrl}
                      alt={stand.nom}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <span className="text-[#C4673D]/30 font-serif text-lg font-bold">
                        {stand.nom}
                      </span>
                    </div>
                  )}
                </div>

                <div className="p-3">
                  <h3 className="font-serif font-bold text-[#332A1C] text-sm leading-tight mb-1.5 group-hover:text-[#C4673D] transition-colors">
                    {stand.nom}
                  </h3>

                  {stand.description && (
                    <p className="text-[#8B7355] text-xs leading-relaxed mb-2 line-clamp-2">
                      {stand.description}
                    </p>
                  )}

                  <span className="text-xs text-[#8B7355]/70">
                    {stand.product_count || 0} produits
                  </span>
                </div>
              </Link>
            );
          })}
        </div>

        {/* Empty state */}
        {filteredStands.length === 0 && stands.length > 0 && (
          <div className="text-center py-16">
            <p className="text-[#8B7355] text-sm">Aucun stand trouv&eacute;</p>
          </div>
        )}
      </div>

      {/* Floating cart bar */}
      {count > 0 && (
        <div className="fixed bottom-0 left-0 right-0 z-50">
          <div className="max-w-lg mx-auto px-4 pb-4">
            <Link
              to="/cart"
              className="flex items-center justify-between bg-white/95 backdrop-blur-sm border border-[#E2D1B8] rounded-2xl px-5 py-4 transition-all"
              style={{ boxShadow: '0 -4px 25px rgba(139,66,37,0.12)' }}
            >
              <div className="flex items-center gap-3">
                <span className="bg-[#C4673D] text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center">
                  {count}
                </span>
                <span className="text-[#332A1C] text-sm font-semibold">
                  Voir le panier
                </span>
              </div>
              <span className="text-[#C4673D] font-bold">
                {total.toFixed(2)}&euro;
              </span>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}
